// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const AvatarContract = contract({
  name: "Avatar",
  description: "User/entity identity for PEOPLE — profile pictures, author rows, member lists, account headers. Circular by default; the AvatarFallback initials read as a person's name. Always include AvatarFallback so load failure doesn't leave a gap.",
  import: "@gradeui/ui",
  aliases: ["profile picture","user image","account image","avatar","person glyph","user avatar","profile image","react native avatar"],
  subcomponents: ["AvatarImage","AvatarFallback"],
  element: "span",
  composesWith: ["Card (in CardHeader)","Table cells","Badge (placed next to for status)","Skeleton (loading state)","Message (in the avatar slot)"],
  styleDefaults: {"AvatarImage":"aspect-square h-full w-full"},
  props: {
  "size": {
      schema: z.enum(["2xs", "xs", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      description: "t-shirt scale, 20px → 80px; default md (40px). xs for chat message rows, sm for comments/dense threads, lg/xl for profile headers. Prefer this over h-*/w-* className utilities.",
  },
  "src": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "alt": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "tone": {
      schema: z.enum(["muted", "primary", "violet", "amber", "emerald", "sky", "rose", "plum", "lime"]).optional(),
      design: "knob",
      description: "tinted bg/text pair. Reach for explicit tones when each author needs a stable colour mapping (chat avatars, comment threads, member lists); default muted.",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "initials (or a small icon), rendered while the image loads or when it fails. Initials auto-scale with the avatar's size (~0.4 of the circle; md = 16px) — do NOT add text-* classes to correct their size.",
  },
  },
});
